module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/PenKnife-ecf6e0d766ccc38bb7db12854bc8a5ff.svg";